import PropTypes from "prop-types";
import { ICON_SIZES } from "app/constants";
function PaiementVisaIcon({ size, ...props }) {
	return (
		<svg
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...(size !== undefined && { width: size, height: size })}
			{...props}
		>
			<path d="M0 4H24V20H0V4Z" fill="white" />
			<path
				d="M9.54005 8.73846L6.88205 15.2615H5.14205L3.82205 10.0492C3.74405 9.72923 3.67205 9.61231 3.43205 9.47693C3.03005 9.26154 2.37605 9.04616 1.80005 8.92308L1.84205 8.72616H4.64405C5.00405 8.72616 5.32205 8.97231 5.40605 9.39693L6.09605 13.1754L7.81205 8.72616H9.54605L9.54005 8.73846ZM16.374 13.1385C16.374 11.4154 14.046 11.3169 14.064 10.5477C14.064 10.3138 14.286 10.0615 14.76 9.99385C15.3181 9.94074 15.8798 10.0428 16.386 10.2892L16.674 8.90462C16.1808 8.71517 15.6587 8.61724 15.132 8.61539C13.506 8.61539 12.36 9.50154 12.348 10.7754C12.336 11.7169 13.164 12.24 13.788 12.56C14.436 12.8738 14.652 13.0831 14.646 13.3662C14.646 13.8031 14.136 14 13.662 14.0062C12.828 14.0185 12.348 13.7785 11.97 13.5938L11.67 15.0277C12.054 15.2062 12.762 15.3662 13.5 15.3723C15.234 15.3723 16.368 14.4985 16.374 13.1385ZM20.676 15.2677H22.2L20.868 8.73846H19.464C19.146 8.73846 18.876 8.92308 18.762 9.21846L16.29 15.2738H18.018L18.36 14.3015H20.478L20.676 15.2738V15.2677ZM18.834 12.9538L19.704 10.4985L20.202 12.96H18.84L18.834 12.9538ZM11.898 8.73846L10.536 15.2738H8.89205L10.254 8.73846H11.898Z"
				fill="#1434CB"
			/>
		</svg>
	);
}

PaiementVisaIcon.propTypes = {
	size: PropTypes.oneOf(Object.values(ICON_SIZES)),
};

export default PaiementVisaIcon;
